import { z } from 'zod';

export const remotePlatformSchema = z.enum(['twitch', 'youtube'] as const);

export type RemotePlatform = z.infer<typeof remotePlatformSchema>;
